/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.tierMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.tier = res.data;
    }
  },
  [storeMutations.tierList]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.tiers = res.data;
    }
  },
  [storeMutations.setTierCount]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.tierCount = res.data.total;
    }
  },
};
export default { ...mutations };
